"use client"

const ContextProvider = ({ children }) => children

export default ContextProvider
